import { Injectable } from '@angular/core';
import { HlDisplayPortalFeaturesService, PriceSettingsGroup } from './hl-display-portal-features.service';
import { AuthService } from 'gung-standard';
import { first, map, Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayHelperService {
  private priceSettings$ = new ReplaySubject<PriceSettingsGroup>(1);
  isSales = false;
  isManager = false;

  constructor(
    private hlDisplayPortalFeatureService: HlDisplayPortalFeaturesService,
    private authService: AuthService
  ) {
    this.hlDisplayPortalFeatureService
      .getPortalFeatureGroup('priceSettingsGroup')
      .pipe(
        first(),
        map(priceSettingsGroup => priceSettingsGroup as PriceSettingsGroup)
      )
      .subscribe(priceSettingsGroup => {
        this.priceSettings$.next(priceSettingsGroup);
      });

    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        roles.indexOf('SALES') > -1 ? (this.isSales = true) : (this.isSales = false);
        roles.indexOf('MANAGER') > -1 ? (this.isManager = true) : (this.isManager = false);
      });
  }

  public checkRequestPricelistAssortmentWithWebCondition(prislista: string): Observable<string> {
    return this.priceSettings$.pipe(
      first(),
      map(priceSettings => {
        let prislistaWithCondition = prislista;
        if (priceSettings.requestPricelistAssortmentWithWebCondition) {
          prislistaWithCondition += '_WEB';
        } else if (!this.isSales) {
          prislistaWithCondition += '_CUSTOMER';
        }
        return prislistaWithCondition;
      })
    );
  }
}
